<ion-item lines="none" class="transparent">
  <h1 #title [class]="'title'+size" [style.text-align]="align">{{label}}</h1>
</ion-item>